import React from "react";
import photo from "../../../assets/personal.jpg";
import "./profile.css";
class Profile extends React.Component {
  constructor() {
    super();

    this.state = {
      display: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    //1 First Way to change state
    // if (this.state.display) {
    //   this.setState({ display: false });
    // } else {
    //   this.setState({ display: true });
    // }
    //2 Second  Way to change state
    // this.setState((prev) => ({ display: !prev.display }));
    //3 Third Way to change state
    this.setState({
      display: !this.state.display,
    });
  }

  render() {
    return (
      <div className="profile">
        <img src={photo} alt="profile" />
        <h1>مرحبا</h1>
        <p className="fw-bold"> اسمي أحمد عليوة وانا مهندس برمجيات</p>

        {this.state.display ? (
          <>
            <p> أحب القراءة وكرة القدم</p>
            <p> فريقي المفضل هو ريال مدريد</p>
            <button className="btn btn-outline-success" onClick={this.toggle}>
              اخفى
            </button>
          </>
        ) : (
          <button className="btn btn-outline-success" onClick={this.toggle}>
            عرض المزيد
          </button>
        )}
      </div>
    );
  }
}
export default Profile;
